import React from 'react';
import { Link } from 'react-router-dom';

const Rules: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">

      <div className="mb-8">
        <Link to="/" className="mb-4 inline-block" style={{ color: 'var(--highlight)' }}>
          ← Back to Home
        </Link>
        <h1 className="text-3xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
          PredictorPro Rules
        </h1>
        <p className="" style={{ color: 'var(--text-secondary)' }}>
          Learn about PredictorPro's rules and scoring system
        </p>
      </div>

      <div className="">
        {/* Rules Content */}
        <div className="mb-8 p-6 rounded-lg" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border)' }}>
          
          <div className="space-y-6">
            <div className="py-4">

              <p className="mb-4">Game play is simple, just choose your predictions and submit them before each games' kick-off time.</p>

              <p className="mb-4"><strong>Scoring</strong></p>
              <p className="mb-4">
              🥇 &nbsp; 1 point for predicting the correct result (i.e. home win)
              </p>
              <p className="mb-4">
              ⚽️ &nbsp; 3 points for predicting the exact score (this is instead of, not in addition to, the correct result score)
              </p>
              <p className="mb-4">
              💷 &nbsp; You are allocated one "banker" per competition's 'match week' and it doubles any correct predictions. If you play your banker on a particular game and you correctly predict the 'exact score' you will receive six points (3+3) for that game, if you correctly predict the result then you will receive two points (1+1) for that game. But please beware, if you incorrectly predict the result you will have one point deducted (-1).
              </p>
         
              <p className="mb-4"><strong>Leagues &amp; Leaderboards</strong></p>

              <p className="mb-4">There are 'official leagues' and global leaderboards for each competition (i.e. National League), and the aim is to win the most points and become champion of the league or leaderboards at the end of the season. The winner will receive a gold trophy, the runner-up a silver trophy, and third place gets a bronze trophy displayed in their trophy room.</p>

              <p className="mb-4">Each competition, also has a monthly view, and at the end of each 'calendar month', the team in first place receives a gold medal, second place receives a silver medal, and third place receive a bronze medal, again displayed in your trophy room. Once a new calendar month starts all points are reset to zero.</p>

              <p className="mb-4"><strong>Player Rankings</strong></p>

              <p className="mb-4">On all 'leaderboards' and 'league standings', when points are equal the higher position goes to the team with the most correct results and, if these are equal, it is the team with the most 'exact scores'. If these are equal, it is the team with the most goals from their 'exact scores'. So, if they predicted an 'exact score' of 2-2 this is better than an 'exact score' of 1-0.</p>

              <p className="mb-4">The scoring detailed above is applied to all 'User leagues' and 'Fans leagues' as well.</p>

              <p className="mb-4">Any issues please email <a href="mailto:support@predictorpro.com" className="hover:underline" style={{ color: 'var(--highlight)' }}>support@predictorpro.com</a> or message us on <a 
                  href="https://discord.gg/CNKjGUKzZJ" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm hover:underline mt-1 inline-block"
                  style={{ color: 'var(--highlight)' }}
                >Discord</a></p>






            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Rules;
